import React from 'react';
import cx from 'classnames';

import styles from './cartItemDetails.module.less';

export const CartItemDetails: React.FC<{ className?: string; smallerFont?: boolean }> = ({
  children,
  className,
  smallerFont = false,
}) => {
  return (
    <div className={cx(styles.cartItemDetails, { [styles.smaller]: smallerFont }, className)}>
      {children}
    </div>
  );
};
